import { AppState } from '../../store';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { createRideTracker } from '@gtforge/ride-tracker-sdk';
import gatewayPath from '../../lib/network/env';
import { EventType } from './entities';

const rideTrackerSDK = createRideTracker(gatewayPath());

export const TRACKING_LOADED = 'TRACKING_LOADED';

export const thunkPushEvent =
    (uuid: string, eventName: EventType): ThunkAction<void, AppState, null, Action<string>> =>
    async (dispatch) => {
        try {
            const req = {
                trackingId: uuid,
                type: eventName,
            };

            await rideTrackerSDK.pushEvent(req);
        } catch (error) {
            const errMessage = error.message ? error.message : `Server error ${error.status}`;
            console.log('Error', errMessage);
        }
    };
